module.exports = __webpack_public_path__ + "static/media/restaurant2.2c044beb.jpg";